// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Slack = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6.5V8H3.5a1.5 1.5 0 0 1 0-3h3A1.5 1.5 0 0 1 8 6.5M8 5H6.5A1.5 1.5 0 1 1 8 3.5zM9.5 8H8V3.5a1.5 1.5 0 0 1 3 0v3A1.5 1.5 0 0 1 9.5 8M11 8V6.5A1.5 1.5 0 1 1 12.5 8zM8 9.5V8h4.5a1.5 1.5 0 0 1 0 3h-3A1.5 1.5 0 0 1 8 9.5M8 11h1.5A1.5 1.5 0 1 1 8 12.5zM6.5 8H8v4.5a1.5 1.5 0 0 1-3 0v-3A1.5 1.5 0 0 1 6.5 8M5 8v1.5A1.5 1.5 0 1 1 3.5 8z"
    />
  </svg>
);
const ForwardRef = forwardRef(Slack);
export default ForwardRef;
